import { Onboarding } from "views/Onboarding";
import { Accounts } from "views/accounts";
import { AccountsPending } from "views/accounts_pending";
import { AgencyDocuments } from "views/agency/Documents";
import { AgencyNotes } from "views/agency/Notes";
import { AgencyOverview } from "views/agency/Overview";
import { Commissions } from "views/agency/Commissions";
import { Bound } from "views/bound";
import { Compliance } from "views/compliance";
import { Dashboard } from "views/dashboard/dashboard";
import { Endorsement } from "views/endorsement";
import { PolicyNotifications } from "views/policy/Notifications";
import { Quote } from "views/quote";
import { ViewQuoteSubmission } from "views/viewQuoteSubmission";
import { ViewPersonalSubmission } from "views/viewPersonalSubmission";
import { RunQuote } from "views/runQuote";
import { RequestedBind } from "views/requested_bind";
import { ReviewQuote } from "views/reviewQuote";
import { ServiceCenter } from "views/service_center";
import TicketPage from "views/service_center/ticket";
import { Support } from "views/support";
import { Users } from "views/users";
import { Renewal } from "../views/renewal";
import RenewalDetails from "../views/renewal/renewal_details";
import RequestedBindDetails from "../views/requested_bind/requested_bind_details";
import { EndorsementsV2 } from "views/endorsementsV2";
import EndorsementsViewV2 from "views/endorsementViewV2";
import { Management } from "views/management";
import { QuickLinksManagement } from "views/management/quick-links";
import { ContactsManagement } from "views/management/contacts";

const Routes = [
  {
    path: "/admin/dashboard",
    view: Dashboard,
    layout: "app",
    permission: "user",
    title: "Dashboard",
  },
  {
    path: "/admin/onboarding",
    view: Onboarding,
    layout: "app",
    permission: "user",
    title: "Onboarding",
  },
  {
    path: "/admin/quote",
    view: Quote,
    layout: "app",
    permission: "user",
    title: "Quotes",
  },
  {
    path: "/admin/resources",
    view: Support,
    layout: "app",
    permission: "user",
    title: "Resources",
  },
  {
    path: "/admin/agency/:id",
    view: AgencyOverview,
    layout: "app",
    permission: "user",
    title: "Agency Overview",
  },
  {
    path: "/admin/agency/:id/notes",
    view: AgencyNotes,
    layout: "app",
    permission: "user",
    title: "Agency Notes",
  },
  {
    path: "/admin/agency/:id/documents",
    view: AgencyDocuments,
    layout: "app",
    permission: "user",
    title: "Agency Documents",
  },
  {
    path: "/admin/agency/:id/commissions",
    view: Commissions,
    layout: "app",
    permission: "user",
    title: "Agency Commissions",
  },
  {
    path: "/admin/coverwhale/quote/review",
    view: ReviewQuote,
    layout: "app",
    permission: "user",
    title: "Review",
  },
  {
    path: "/admin/progressive/quote/review",
    view: ReviewQuote,
    layout: "app",
    permission: "user",
    title: "Review Progressive Quote",
  },
  {
    path: "/admin/quote/form",
    view: RunQuote,
    layout: "app",
    permission: "user",
    title: "Quote Form",
  },
  {
    path: "/admin/coverwhale/quote/form",
    view: RunQuote,
    layout: "app",
    permission: "user",
    title: "Quote Form",
  },
  {
    path: "/admin/requestedbind",
    view: RequestedBind,
    layout: "app",
    permission: "user",
    title: "Requested Bind",
  },
  {
    path: "/admin/requestedbind/:id",
    view: RequestedBindDetails,
    layout: "app",
    permission: "user",
    title: "Requested Bind",
  },
  {
    path: "/admin/policies",
    view: Bound,
    layout: "app",
    permission: "user",
    title: "Policies",
  },

  {
    path: "/admin/policy/:id",
    view: PolicyNotifications,
    layout: "app",
    permission: "user",
    title: "Policy",
  },
  {
    path: "/admin/users",
    view: Users,
    layout: "app",
    permission: "admin",
    title: "Users",
  },
  {
    path: "/admin/agencies",
    view: Accounts,
    layout: "app",
    permission: "admin",
    title: "Agencies",
  },
  {
    path: "/admin/compliance",
    view: Compliance,
    layout: "app",
    permission: "admin",
    title: "Compliance",
  },
  {
    path: "/admin/agencies/pending",
    view: AccountsPending,
    layout: "app",
    permission: "admin",
    title: "Agencies",
  },
  // {
  //   path: '/admin/endorsements',
  //   view: Endorsements,
  //   layout: 'app',
  //   permission: 'admin',
  //   title: 'Endorsements',
  // },
  {
    path: "admin/endorsements",
    view: EndorsementsV2,
    layout: "app",
    permission: "admin",
    title: "Endorsements",
  },
  {
    path: "/admin/endorsement/v2/:id",
    view: EndorsementsViewV2,
    layout: "app",
    permission: "admin",
    title: "Endorsement V2",
  },
  // {
  //   path: '/admin/endorsement/view',
  //   view: EndorsementView,
  //   layout: 'app',
  //   permission: 'admin',
  //   title: 'Endorsement View',
  // },
  {
    path: "/admin/endorsement/:id",
    view: EndorsementsViewV2,
    layout: "app",
    permission: "admin",
    title: "Endorsement",
  },
  {
    path: "/admin/service_center",
    view: ServiceCenter,
    layout: "app",
    permission: "user",
    title: "Service Center",
  },
  {
    path: "/admin/service_center/ticket/:id",
    view: TicketPage,
    layout: "app",
    permission: "user",
    title: "Service Center",
  },
  {
    path: "/admin/renewal",
    view: Renewal,
    layout: "app",
    permission: "admin",
    title: "Renewal",
  },
  {
    path: "/admin/renewal/:id",
    view: RenewalDetails,
    layout: "app",
    permission: "admin",
    title: "Renewal",
  },
  {
    path: "/admin/management",
    view: Management,
    layout: "app",
    permission: "admin",
    title: "Management",
  },
  {
    path: "/admin/management/quick-links",
    view: QuickLinksManagement,
    layout: "app",
    permission: "admin",
    title: "Quick Links Management",
  },
  {
    path: "/admin/management/contacts",
    view: ContactsManagement,
    layout: "app",
    permission: "admin",
    title: "Contacts Management",
  },
  {
    path: "/admin/quote-submission/view/:id",
    view: ViewQuoteSubmission,
    layout: "app",
    permission: "user",
    title: "Commercial Submissions",
  },
  {
    path: "/admin/quote-submission/view",
    view: ViewQuoteSubmission,
    layout: "app",
    permission: "user",
    title: "Commercial Submissions",
  },
  {
    path: "/admin/personal-submission/view/:id",
    view: ViewPersonalSubmission,
    layout: "app",
    permission: "user",
    title: "Personal Submissions",
  },
  {
    path: "/admin/personal-submission/view",
    view: ViewPersonalSubmission,
    layout: "app",
    permission: "user",
    title: "Personal Submissions",
  },
];

export default Routes;
